module.exports = __webpack_public_path__ + "static/media/user.187550a7.svg";